import React from "react";
import { Controller } from "react-hook-form";
import type { SubmissionDefaultValuesPath } from "common/services/formBuilderService";
import type { PathArray } from "common/utils/formStructure";
import Select from "../../../../../../../Inputs/Select";
import {
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
  useBuilderWatch,
} from "../../../form/form";

type TextDynamicDefaultInputProps = {
  fieldPath: PathArray;
  isReadOnly: boolean;
};

export function TextDynamicDefaultInput({
  fieldPath,
  isReadOnly,
}: TextDynamicDefaultInputProps) {
  const { control } = useBuilderFormContext();
  const defaultValuePathPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "defaultValuePath",
  );
  const defaultValuePath = useBuilderWatch(defaultValuePathPropertyFormPath);

  return (
    <Controller
      control={control}
      name={defaultValuePathPropertyFormPath}
      render={({ field }) => {
        return (
          <Select
            value={defaultValuePath ?? null}
            isClearable={true}
            label="Dynamic default value"
            name={defaultValuePathPropertyFormPath}
            options={inputOptions}
            onChange={value => {
              field.onChange(value ?? undefined);
            }}
            disabled={isReadOnly}
          />
        );
      }}
    />
  );
}

const inputOptions: Array<{
  value: SubmissionDefaultValuesPath;
  label: string;
}> = [
  {
    value: "parcel.block",
    label: "Parcel > Block",
  },
  {
    value: "parcel.parcelId",
    label: "Parcel > ID",
  },
  {
    value: "parcel.improvementValue",
    label: "Parcel > Improvement value",
  },
  {
    value: "parcel.lot",
    label: "Parcel > Lot",
  },
  {
    value: "parcel.mailingAddress",
    label: "Parcel > Mailing address",
  },
  {
    value: "parcel.mailingAddress1",
    label: "Parcel > Mailing address 1",
  },
  {
    value: "parcel.mailingAddress2",
    label: "Parcel > Mailing address 2",
  },
  {
    value: "parcel.ownerName",
    label: "Parcel > Owner name",
  },
  {
    value: "property.improvementValue",
    label: "Property > Improvement value",
  },
  {
    value: "property.latitude",
    label: "Property > Latitude",
  },
  {
    value: "property.longitude",
    label: "Property > Longitude",
  },
  {
    value: "property.sisd.adjustmentRatio",
    label: "Property > SI/SD > Adjustment ratio",
  },
  {
    value: "user.firstName",
    label: "User > First name",
  },
  {
    value: "user.lastName",
    label: "User > Last name",
  },
  {
    value: "user.fullName",
    label: "User > Full name",
  },
];
